import { Component } from '@angular/core';

@Component({
    selector: 'privacy',
    templateUrl: './privacy.component.html'
})
export class PrivacyComponent {
}



// WEBPACK FOOTER //
// ./src/app/components/privacy/privacy.component.ts